import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      PLAN: "Planlegg",
      CALENDAR: "Kalender",
      RECIPES: "Oppskrifter",
      ACCOUNT: "Konto",
      CUSTOMER_SERVICE: "Kundeservice",
      ADDONS: "Dagligvarer",
      MEALS: "Middager",
      ORDER: "Bestilling",
    },
    se: {
      PLAN: "Planera",
      CALENDAR: "Kalender",
      RECIPES: "Recept",
      ACCOUNT: "Konto",
      CUSTOMER_SERVICE: "Kundservice",
      ADDONS: "Livsmedel",
      MEALS: "Middagar",
      ORDER: "Beställning",
    },
    dk: {
      PLAN: "Planlæg",
      CALENDAR: "Kalender",
      RECIPES: "Opskrifter",
      ACCOUNT: "Konto",
      CUSTOMER_SERVICE: "Kundeservice",
      ADDONS: "Dagligvarer",
      MEALS: "Retter",
      ORDER: "Bestilling",
    },
  } as const
)[language];
